import type { ComponentProps, ReactNode } from "react";

import { Flex, isNullish, mergeProps, Text, Button } from "@theorgchartdev/storybook";

type TextProps = ComponentProps<typeof Text>;

type Props = {
  children: ReactNode;
  id: string;

  label: string;
  labelSize?: TextProps["size"];
  labelInfo?: string;

  helper?: string;
  helperSize?: TextProps["size"];
};

export const FieldInputLabel = (props: Props) => {
  props = mergeProps(props, defaultProps);
  return (
    <label htmlFor={props.id}>
      <Flex
        className="oc-cursor-pointer"
        direction="row"
        alignItems="flex-start"
        justifyContent="space-between"
      >
        <Flex direction="column">
          <Flex direction="row">
            {props.labelInfo && (
              <Button
                tooltipProps={{
                  message: props.labelInfo,
                  position: "top-start"
                }}
                modifier={"tertiary"}
                iconOnly={true}
                iconProps={{ name: "circle-info" }}
              />
            )}
            <Text size={props.labelSize} modifier="bold">
              {props.label}
            </Text>
          </Flex>
          {!isNullish(props.helper) && (
            <Text size={props.helperSize} colorModifier="grey">
              {props.helper}
            </Text>
          )}
        </Flex>
        {props.children}
      </Flex>
    </label>
  );
};

const defaultProps = {
  labelSize: "medium",
  helperSize: "small"
};
